import React, { useEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import { useScrollVisibility } from '../../hooks/useScrollVisibility';
import Style from './style.module.scss';

const Tabs = ({ tabs, defaultActiveKey, onChange, isKvkkPage }) => {
  const [activeKey, setActiveKey] = useState(defaultActiveKey || tabs[0]?.key);
  const tabBarRef = useRef(null);
  const isSticky = useScrollVisibility();

  useEffect(() => {
    const container = tabBarRef.current;
    const activeButton = container?.querySelector(`.${Style.active}`);

    if (activeButton && container) {
      activeButton.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'start',
      });
    }
  }, [activeKey]);

  const activeTab = tabs.find((tab) => tab.key === activeKey);

  const handleChange = (key) => {
    window.scrollTo(0, 0);
    setActiveKey(key);
    onChange?.(key);
  };

  return (
    <div className={Style.wrapper}>
      <div
        ref={tabBarRef}
        className={clsx(
          Style.tabBar,
          { [Style.policiesBar]: isKvkkPage },
          { [Style.sticky]: isSticky }
        )}
      >
        {tabs.map((tab) => (
          <button
            key={tab.key}
            className={clsx(Style.tab, activeKey === tab.key && Style.active)}
            onClick={() => handleChange(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className={Style.content}>{activeTab?.content}</div>
    </div>
  );
};

export default Tabs;
